import React from 'react';
import { useMachine } from '@xstate/react';
import { useAccountContext } from 'contexts/account';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ACTIVE_WHALE_PLAN_LIMIT } from '../../payment-methods.api';
import { addPaymentMethodMachine } from './add-payment-method-machine';
import { StyledModal } from '../../payment-methods.style';

interface Props {
  close: () => void;
  existingPaymentMethodIds: number[];
  activePlans: ActivePlan[];
  activePlanCount: number;
}

export const AddPaymentMethodModal = ({
  close,
  existingPaymentMethodIds,
  activePlans,
  activePlanCount,
}: Props) => {
  const { selectedAccountId } = useAccountContext();
  const flag = useFlags();

  const [current, send] = useMachine(addPaymentMethodMachine, {
    context: {
      accountId: selectedAccountId,
      existingPaymentMethodIds,
      activePlans,
      isActivePlanWhale: activePlanCount > ACTIVE_WHALE_PLAN_LIMIT,
      shouldCreatePaymentHold: flag.csPlaceCardHoldDashboard,
    } as Partial<AddPaymentMethodContext>,
  });

  /*  @ts-expect-error TODO type this */
  const { Component } = Object.values(current.meta)[0];

  return (
    <StyledModal aria-label="add payment">
      <Component
        close={close}
        next={() => send('next')}
        context={current.context}
        matches={current.matches}
        send={send}
      />
    </StyledModal>
  );
};
